import script from "./JsonProperty.vue?vue&type=script&setup=true&lang=js"
export * from "./JsonProperty.vue?vue&type=script&setup=true&lang=js"

import "./JsonProperty.vue?vue&type=style&index=0&id=8025fd46&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8025fd46"]])

export default __exports__